import { DeviceData } from '../group-energy-stats/model';

export const devices: DeviceData[] = [
  {
    serial: 'XLUM00001',
    name: 'XeoLum+ 1',
    type: 'XEO',
    alive: true,
    power: 12.5,
    totalEnergy: 3850.4,
    current: 54.3,
    voltage: 231,
    temperature: 36,
    fw: '2.4.1',
    lastUpdate: '2025-10-09T10:32:12Z',
    phases: {
      voltages: {
        phases: { R: 231.2, S: 229.8, T: 230.5 }
      },
      currents: {
        phases: { R: 18.5, S: 17.8, T: 18.0 }
      },
      powers: {
        active: { R: 4.28, S: 4.09, T: 4.15 },
        reactive: { R: 0.85, S: 0.82, T: 0.83 },
        apparent: { R: 4.36, S: 4.17, T: 4.23 },
        total: { active: 12.52, reactive: 2.50, apparent: 12.77 }
      },
      powerFactor: { R: 0.98, S: 0.98, T: 0.98 },
      frequency: 50.02,
      lastUpdate: '2025-10-09T10:32:12Z'
    },
    history: {
      energy: { values: [185, 210, 195, 225, 208, 245, 220, 238, 215], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [10.5, 11.2, 11.8, 12.1, 12.3, 12.5, 12.6, 12.7, 12.8], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [22, 24, 21, 25, 23, 26, 24, 25, 23], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [229,229,230,230,231,231,231,232,232], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '07:00', end: '22:00', action: { type: 'enable' } }, // 31 = lunes a viernes (1+2+4+8+16)
          { daysOfWeek: 96, start: '09:00', end: '18:00', action: { type: 'setPowerLimit', params: { limitKw: 3.5 } } } // 96 = sábado y domingo (32+64)
        ],
        values: { power: 7.8, voltage: 231, current: 33.8, maxPower: 22.0, lastUpdate: '2025-10-09T10:32:10Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '08:30', end: '19:00', action: { type: 'enable' } }, // 31 = lunes a viernes (1+2+4+8+16)
          { daysOfWeek: 96, start: '00:00', end: '23:59', action: { type: 'disable' } } // 96 = sábado y domingo (32+64)
        ],
        values: { power: 4.7, voltage: 231, current: 20.5, maxPower: 14.0, lastUpdate: '2025-10-09T10:32:10Z' }
      }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: true, voltage: 230, current: 8.5, power: 1.96, lastUpdate: '2025-10-09T10:31:50Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: true, voltage: 229, current: 7.2, power: 1.65, lastUpdate: '2025-10-09T10:31:55Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: true, voltage: 231, current: 5.8, power: 1.34, lastUpdate: '2025-10-09T10:32:02Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: true, voltage: 230, current: 3.2, power: 0.74, lastUpdate: '2025-10-09T10:32:05Z' }
    ]
  },

  {
    serial: 'XLUM00002',
    name: 'XeoLum+ 2',
    type: 'XEO',
    alive: true,
    power: 10.8,
    totalEnergy: 3520.5,
    current: 47.2,
    voltage: 230,
    temperature: 34,
    fw: '2.4.0',
    lastUpdate: '2025-10-09T10:33:18Z',
    phases: {
      voltages: {
        phases: { R: 230.1, S: 229.7, T: 230.3 }
      },
      currents: {
        phases: { R: 15.7, S: 15.8, T: 15.7 }
      },
      powers: {
        active: { R: 3.61, S: 3.63, T: 3.60 },
        reactive: { R: 0.72, S: 0.73, T: 0.72 },
        apparent: { R: 3.68, S: 3.70, T: 3.67 },
        total: { active: 10.84, reactive: 2.17, apparent: 11.05 }
      },
      powerFactor: { R: 0.98, S: 0.98, T: 0.98 },
      frequency: 50.01,
      lastUpdate: '2025-10-09T10:33:18Z'
    },
    history: {
      energy: { values: [172, 195, 178, 215, 198, 225, 205, 235, 210], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [9.8, 10.1, 10.3, 10.5, 10.6, 10.8, 11.0, 11.1, 11.2], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [20, 23, 21, 24, 22, 25, 23, 24, 22], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [229,230,230,231,231,231,231,232,232], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '08:00', end: '20:00', action: { type: 'enable' } } // 31 = lunes a viernes (1+2+4+8+16)
        ],
        values: { power: 6.5, voltage: 230, current: 28.3, maxPower: 20.0, lastUpdate: '2025-10-09T10:33:15Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '06:30', end: '14:30', action: { type: 'enable' } }, // 31 = lunes a viernes (1+2+4+8+16)
          { daysOfWeek: 32, start: '09:00', end: '13:00', action: { type: 'enable' } }, // 32 = sábado (32)
          { daysOfWeek: 64, start: '00:00', end: '23:59', action: { type: 'disable' } } // 64 = domingo (64)
        ],
        values: { power: 4.3, voltage: 230, current: 18.7, maxPower: 13.0, lastUpdate: '2025-10-09T10:33:15Z' }
      }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: true, voltage: 230, current: 7.5, power: 1.73, lastUpdate: '2025-10-09T10:33:00Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: true, voltage: 231, current: 6.2, power: 1.43, lastUpdate: '2025-10-09T10:33:02Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: true, voltage: 229, current: 4.8, power: 1.10, lastUpdate: '2025-10-09T10:33:05Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: true, voltage: 230, current: 3.5, power: 0.81, lastUpdate: '2025-10-09T10:33:07Z' }
    ]
  },

  {
    serial: 'XLUM00003',
    name: 'XeoLum+ 3',
    type: 'XEO',
    alive: true,
    power: 8.6,
    totalEnergy: 2890.3,
    current: 37.5,
    voltage: 229,
    temperature: 40,
    fw: '2.3.8',
    lastUpdate: '2025-10-09T10:34:25Z',
    phases: {
      voltages: {
        phases: { R: 229.1, S: 228.8, T: 229.2 }
      },
      currents: {
        phases: { R: 12.5, S: 12.4, T: 12.6 }
      },
      powers: {
        active: { R: 2.86, S: 2.84, T: 2.90 },
        reactive: { R: 0.57, S: 0.57, T: 0.58 },
        apparent: { R: 2.92, S: 2.90, T: 2.96 },
        total: { active: 8.60, reactive: 1.72, apparent: 8.78 }
      },
      powerFactor: { R: 0.98, S: 0.98, T: 0.98 },
      frequency: 49.99,
      lastUpdate: '2025-10-09T10:34:25Z'
    },
    history: {
      energy: { values: [158, 178, 185, 202, 188, 210, 195, 215, 198], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [7.5, 7.8, 8.2, 8.5, 8.7, 8.9, 9.1, 9.3, 9.5], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [18, 19, 18, 21, 20, 22, 19, 21, 20], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [227,228,228,229,229,230,230,231,231], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 127, start: '06:00', end: '20:00', action: { type: 'enable' } } // 127 = todos los días (1+2+4+8+16+32+64)
        ],
        values: { power: 1.8, voltage: 229, current: 7.86, maxPower: 2.5, lastUpdate: '2025-10-09T10:34:20Z' }
      },
      out2: {
        enabled: false,
        rules: [],
        values: { power: 0, voltage: 229, current: 0, maxPower: 0, lastUpdate: '2025-10-09T10:34:20Z' }
      }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: true, voltage: 229, current: 2.1, power: 0.48, lastUpdate: '2025-10-09T10:34:05Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: true, voltage: 230, current: 1.6, power: 0.37, lastUpdate: '2025-10-09T10:34:08Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: true, voltage: 228, current: 1.1, power: 0.25, lastUpdate: '2025-10-09T10:34:12Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: true, voltage: 229, current: 0.7, power: 0.16, lastUpdate: '2025-10-09T10:34:15Z' }
    ]
  },

  {
    serial: 'XLUM00004',
    name: 'XeoLum+ 4',
    type: 'XEO',
    alive: true,
    power: 7.5,
    totalEnergy: 2520.1,
    current: 32.9,
    voltage: 228,
    temperature: 33,
    fw: '2.4.1',
    lastUpdate: '2025-10-09T10:35:10Z',
    phases: {
      voltages: {
        phases: { R: 228.2, S: 227.8, T: 228.0 }
      },
      currents: {
        phases: { R: 11.0, S: 10.9, T: 11.0 }
      },
      powers: {
        active: { R: 2.51, S: 2.48, T: 2.51 },
        reactive: { R: 0.50, S: 0.50, T: 0.50 },
        apparent: { R: 2.56, S: 2.53, T: 2.56 },
        total: { active: 7.50, reactive: 1.50, apparent: 7.65 }
      },
      powerFactor: { R: 0.98, S: 0.98, T: 0.98 },
      frequency: 50.00,
      lastUpdate: '2025-10-09T10:35:10Z'
    },
    history: {
      energy: { values: [145, 162, 155, 178, 172, 185, 168, 175, 170], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [6.5, 6.8, 7.0, 7.2, 7.4, 7.6, 7.8, 7.9, 8.0], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [17, 19, 18, 20, 19, 21, 19, 20, 19], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [226,226,226,227,230,228,228,229,229], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '00:00', end: '06:00', action: { type: 'disable' } }, // 31 = lunes a viernes (1+2+4+8+16)
          { daysOfWeek: 31, start: '06:00', end: '23:59', action: { type: 'enable' } } // 31 = lunes a viernes (1+2+4+8+16)
        ],
        values: { power: 1.0, voltage: 228, current: 4.39, maxPower: 1.8, lastUpdate: '2025-10-09T10:35:05Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 32, start: '10:00', end: '14:00', action: { type: 'enable' } }, // 32 = sábado (32)
          { daysOfWeek: 64, start: '00:00', end: '23:59', action: { type: 'disable' } } // 64 = domingo (64)
        ],
        values: { power: 0.5, voltage: 228, current: 2.19, maxPower: 1.0, lastUpdate: '2025-10-09T10:35:05Z' }
      }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: true, voltage: 228, current: 1.9, power: 0.43, lastUpdate: '2025-10-09T10:34:58Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: true, voltage: 227, current: 1.4, power: 0.32, lastUpdate: '2025-10-09T10:35:00Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: true, voltage: 229, current: 0.9, power: 0.21, lastUpdate: '2025-10-09T10:35:03Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: true, voltage: 228, current: 0.5, power: 0.11, lastUpdate: '2025-10-09T10:35:06Z' }
    ]
  },

  {
    serial: 'XLUM00005',
    name: 'XeoLum+ 5',
    type: 'XEO',
    alive: false,
    power: 0,
    totalEnergy: 102.4,
    current: 0,
    voltage: 0,
    temperature: 0,
    fw: '2.3.5',
    lastUpdate: '2025-10-07T15:22:33Z',
    phases: {
      voltages: {
        phases: { R: 0, S: 0, T: 0 }
      },
      currents: {
        phases: { R: 0, S: 0, T: 0 }
      },
      powers: {
        active: { R: 0, S: 0, T: 0 },
        reactive: { R: 0, S: 0, T: 0 },
        apparent: { R: 0, S: 0, T: 0 },
        total: { active: 0, reactive: 0, apparent: 0 }
      },
      powerFactor: { R: 0, S: 0, T: 0 },
      frequency: 0,
      lastUpdate: '2025-10-07T15:22:33Z'
    },
    history: {
      energy: { values: [12, 18, 15, 22, 19, 16, 21, 17, 14], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [1.0, 1.1, 1.2, 1.3, 1.3, 1.4, 1.5, 1.5, 1.6], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [3.5, 3.8, 3.2, 4.0, 3.6, 3.9, 3.7, 3.4, 3.6], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [230,230,231,231,231,232,232,232,233], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: { enabled: false, rules: [], values: { power: 0, voltage: 0, current: 0, maxPower: 0, lastUpdate: '2025-10-09T08:12:00Z' } },
      out2: { enabled: false, rules: [], values: { power: 0, voltage: 0, current: 0, maxPower: 0, lastUpdate: '2025-10-09T08:12:00Z' } }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: false, voltage: 0, current: 0, power: 0, lastUpdate: '2025-10-09T08:11:50Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: false, voltage: 0, current: 0, power: 0, lastUpdate: '2025-10-09T08:11:50Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: false, voltage: 0, current: 0, power: 0, lastUpdate: '2025-10-09T08:11:50Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: false, voltage: 0, current: 0, power: 0, lastUpdate: '2025-10-09T08:11:50Z' }
    ]
  },

  {
    serial: 'XLUM00006',
    name: 'XeoLum+ 6',
    type: 'XEO',
    alive: true,
    power: 15.2,
    totalEnergy: 4260.8,
    current: 66.4,
    voltage: 229,
    temperature: 40,
    fw: '2.4.2',
    lastUpdate: '2025-10-09T10:35:45Z',
    phases: {
      voltages: {
        phases: { R: 229.3, S: 228.7, T: 229.0 }
      },
      currents: {
        phases: { R: 22.1, S: 22.2, T: 22.1 }
      },
      powers: {
        active: { R: 5.07, S: 5.08, T: 5.05 },
        reactive: { R: 1.01, S: 1.02, T: 1.01 },
        apparent: { R: 5.17, S: 5.18, T: 5.15 },
        total: { active: 15.20, reactive: 3.04, apparent: 15.50 }
      },
      powerFactor: { R: 0.98, S: 0.98, T: 0.98 },
      frequency: 50.01,
      lastUpdate: '2025-10-09T10:35:45Z'
    },
    history: {
      energy: { values: [198, 230, 215, 248, 225, 265, 238, 255, 242], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageMaxPowerDemand: { values: [12.5, 13.0, 13.5, 14.0, 14.5, 15.0, 15.2, 15.3, 15.5], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      maxPower: { values: [24, 26, 25, 28, 26, 29, 27, 28, 27], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] },
      averageVoltage: { values: [229,229,229,230,230,230,231,231,231], labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep'] }
    },
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '22:00', end: '06:00', action: { type: 'enable' } }, // 31 = lunes a viernes (1+2+4+8+16)
          { daysOfWeek: 96, start: '00:00', end: '23:59', action: { type: 'disable' } } // 96 = sábado y domingo (32+64)
        ],
        values: { power: 4.5, voltage: 229, current: 19.57, maxPower: 6.0, lastUpdate: '2025-10-09T10:37:55Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 32, start: '18:00', end: '23:59', action: { type: 'enable' } }, // 32 = sábado (32)
          { daysOfWeek: 64, start: '08:00', end: '12:00', action: { type: 'enable' } } // 64 = domingo (64)
        ],
        values: { power: 2.7, voltage: 229, current: 11.79, maxPower: 4.0, lastUpdate: '2025-10-09T10:37:55Z' }
      }
    },
    satelites: [
      { id: 'XS1', name: 'XeoSwitch 1', alive: true, voltage: 229, current: 5.8, power: 1.33, lastUpdate: '2025-10-09T10:37:40Z' },
      { id: 'XS2', name: 'XeoSwitch 2', alive: true, voltage: 230, current: 4.2, power: 0.97, lastUpdate: '2025-10-09T10:37:42Z' },
      { id: 'XS3', name: 'XeoSwitch 3', alive: true, voltage: 230, current: 2.7, power: 0.62, lastUpdate: '2025-10-09T10:37:45Z' },
      { id: 'XS4', name: 'XeoSwitch 4', alive: true, voltage: 231, current: 1.5, power: 0.35, lastUpdate: '2025-10-09T10:37:47Z' }
    ]
  },

  {
    serial: 'ANC00001',
    name: 'Astronómico 1',
    type: 'ANC',
    alive: true,
    power: 5.8,
    totalEnergy: 2156.3,
    current: 25.2,
    voltage: 230,
    temperature: 42,
    fw: '1.8.3',
    lastUpdate: '2025-10-09T10:36:15Z',
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 127, start: 'OCASO', end: '23:59', action: { type: 'enable' } } // Desde atardecer hasta las 23:59 todos los días
        ],
        values: { power: 5.8, voltage: 230, current: 25.2, maxPower: 20.0, lastUpdate: '2025-10-09T11:15:30Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '00:00', end: 'ORTO', action: { type: 'enable' } }, // Desde medianoche hasta amanecer (lunes a viernes)
          { daysOfWeek: 31, start: 'OCASO', end: '23:59', action: { type: 'enable' } }  // Desde atardecer hasta medianoche (lunes a viernes)
        ],
        values: { power: 3.2, voltage: 230, current: 13.9, maxPower: 12.0, lastUpdate: '2025-10-09T11:15:30Z' }
      }
    }
  },

  {
    serial: 'ANC00002',
    name: 'Astronómico 2',
    type: 'ANC',
    alive: true,
    power: 3.4,
    totalEnergy: 1685.9,
    current: 14.8,
    voltage: 229,
    temperature: 38,
    fw: '1.8.1',
    lastUpdate: '2025-10-09T10:36:42Z',
    schedule: {
      timezone: 'Europe/Madrid',
      out1: {
        enabled: true,
        rules: [
          { daysOfWeek: 96, start: 'OCASO', end: 'ORTO', action: { type: 'enable' } } // Desde atardecer hasta amanecer (sábados y domingos)
        ],
        values: { power: 3.4, voltage: 229, current: 14.8, maxPower: 15.0, lastUpdate: '2025-10-09T11:16:45Z' }
      },
      out2: {
        enabled: true,
        rules: [
          { daysOfWeek: 31, start: '18:00', end: 'OCASO', action: { type: 'enable' } } // Desde las 18:00 hasta el atardecer (lunes a viernes)
        ],
        values: { power: 1.8, voltage: 229, current: 7.8, maxPower: 8.0, lastUpdate: '2025-10-09T11:16:45Z' }
      }
    }
  }
];
